import React from 'react'
import ContentLoader from 'react-content-loader'

const LoaderAside = ({  }) => {



    return (
      <ContentLoader
        speed={2}
        width={270}
        height={80}
        viewBox={`0 0 270 80`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
          <>
            <>
              <rect x="10" y="0" rx="3" ry="3" width="150" height="15" />
              <rect x="10" y="30" rx="3" ry="3" width="150" height="15" />
              <rect x="10" y="60" rx="3" ry="3" width="150" height="15" />
            </>
          </>
      </ContentLoader>
    )

}

export default LoaderAside